module.exports = __webpack_public_path__ + "45a182efcc0a6191536aa3cebef44188.woff2";